<div class="py-6">
  <app-table
      [loading]="loading"
      [data]="tableData"
      [columns]="tableColumns"
      [pageSize]="50"
      id="table-nomOrgProjectTable" />
</div>
